<template>
    <button type="button" 
        class="rounded w-full my-1 border text-sm2 font-medium" 
        role="button" 
        @click="clicked" 
        :class="buttonClass" 
        @mouseover="hover_tag=true" 
        @mouseleave="hover_tag=false"
        :disabled="disable_button">
        <p v-if="usedFor == 'file-and-tag'">
            <span v-if="!disable_button">
                {{ (truncate) ? tag.abbv : tag.name }}
            </span>

            <span v-else>
                <i class="fa fa-spin fa-circle-notch"></i>
            </span>
        </p>

        <p v-if="usedFor == 'searching'">
            {{ (truncate) ? tag.abbv : tag.name }}
        </p>
    </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ["tag", "selectedFiles", "truncate", "used-for"],

  data() {
    return {
      hover_tag: false,
      disable_button: false
    };
  },

  methods: {
    clicked() {
      if (!_.isEmpty(this.selectedFiles)) {
        if(this.usedFor == 'file-and-tag' && this.role == 'userD') {
          return;
        }
        if (this.usedFor != "searching") {
          this.disable_button = true;
        }
        if (this.isInAllFiles) {
          this.$emit("untagged", this.tag);
        } else {
          this.$emit("tagged", this.tag);
        }
      }
    }
  },

  mounted() {
    this.$ebus.$on("tag-success", payload => {
      let tag = payload;

      if (tag.id == this.tag.id && this.disable_button) {
        this.disable_button = false;
        this.hover_tag = false;
      }
    });

    this.$ebus.$on("untag-success", payload => {
      let tag = payload;

      if (tag.id == this.tag.id && this.disable_button) {
        this.disable_button = false;
        this.hover_tag = false;
      }
    });

    this.$ebus.$on("remove-tag-loading", payload => {
      if (this.disable_button) {
        this.disable_button = false;
        this.hover_tag = false;
      }
    });
  },

  computed: {
    ...mapGetters({
      role: "getUserRole",
    }),

    disabled() {
      if(this.usedFor == 'file-and-tag' && this.role == 'userD') {
        return true;
      }
      return this.selectedFiles.length === 0;
    },

    isInAllFiles() {
      let result = true;

      if (this.selectedFiles.length === 0) {
        return false;
      }

      // If any of the tags are empty, then it's a sure bet that we're not in all
      _.each(this.selectedFiles, (file, key) => {
        if (_.isEmpty(file.tags)) {
          result = false;
        } else {
          // If there are tags but we're not in them, then it's the same case
          if (_.isUndefined(_.find(file.tags, ["id", this.tag.id]))) {
            result = false;
          }
        }
      });

      return result;
    },

    isInSomeFiles() {
      let result = false;

      _.each(this.selectedFiles, file => {
        _.each(file.tags, tag => {
          if (tag.id === this.tag.id) {
            result = true;
          }
        });
      });

      return result;
    },

    isNotInAnyFile() {
      return !this.isInAllFiles;
    },

    // Three states: on none of the selected files (outline), on some (dashed brand outline),
    // on all (filled). Disabled and in-flight states dim whatever state applies.
    buttonClass() {
      const partial = this.isInSomeFiles && !this.isInAllFiles;
      return {
        "bg-white border-grey text-grey-darker": !this.isInSomeFiles,
        "bg-white border-brand border-dashed text-brand": partial,
        "border-brand bg-brand text-white": this.isInAllFiles,
        "border-brand": this.hover_tag && !this.disabled,
        "cursor-not-allowed opacity-50": this.disabled || this.disable_button
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-button {
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  display: block;
  overflow: hidden;
}
</style>
